import React from 'react';
import { Section } from '../ui/Section';
import { Check, FileText } from 'lucide-react';
export function WhatIncluded() {
  const items = [{
    title: 'Setup de 3 minutos',
    desc: 'Para dejar de improvisar antes de dormir.'
  }, {
    title: 'Rutina CALMAR-12',
    desc: 'Paso a paso, minuto a minuto. Sin adivinanzas.'
  }, {
    title: 'Posición Cero',
    desc: 'La técnica exacta para dormir con muñeca neutral.'
  }, {
    title: 'El "Mapa del Punzazo"',
    desc: 'Para adaptar la rutina según qué tan mala sea tu noche.'
  }, {
    title: 'Protocolo de 4 minutos',
    desc: 'Salvavidas si te despiertas entre 2–4am.'
  }, {
    title: 'Checklist y Tracker',
    desc: '14 noches de seguimiento para ver tu progreso.'
  }];
  return <Section background="navy" data-id="element-156">
      <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-157">
        <div data-id="element-158">
          <h2 className="text-3xl md:text-4xl font-bold text-[#f5f0e8] mb-6 font-serif" data-id="element-159">
            Qué es <span className="text-[#d4af37]" data-id="element-160">Sueño Sin Dolor</span>
          </h2>
          <p className="text-lg text-gray-400 mb-8" data-id="element-161">
            Un PDF práctico, directo y sin tecnicismos médicos confusos.
            Diseñado para leerse en 20 minutos y aplicarse esa misma noche.
          </p>

          <div className="space-y-4" data-id="element-162">
            {items.map((item, idx) => <div key={idx} className="flex gap-4 p-4 rounded-lg bg-[#0f1419]/50 border border-[#2a3245] hover:border-[#d4af37]/20 transition-all" data-id="element-163">
                <div className="mt-1 text-[#d4af37]" data-id="element-164">
                  <Check size={20} data-id="element-165" />
                </div>
                <div data-id="element-166">
                  <h4 className="text-[#f5f0e8] font-medium" data-id="element-167">{item.title}</h4>
                  <p className="text-sm text-gray-400" data-id="element-168">{item.desc}</p>
                </div>
              </div>)}
          </div>
        </div>

        <div className="relative flex justify-center" data-id="element-169">
          <div className="relative w-full max-w-md aspect-[3/4] bg-[#0f1419] rounded-xl border border-[#2a3245] shadow-2xl p-8 flex flex-col items-center justify-center text-center" data-id="element-170">
            <FileText className="w-20 h-20 text-[#d4af37] mb-6 opacity-80" data-id="element-171" />
            <h3 className="text-2xl font-serif text-[#f5f0e8] mb-2" data-id="element-172">
              Guía Digital (PDF)
            </h3>
            <p className="text-gray-400 mb-8" data-id="element-173">Descarga inmediata</p>
            <div className="w-full h-1 bg-[#2a3245] rounded-full mb-4 overflow-hidden" data-id="element-174">
              <div className="w-2/3 h-full bg-[#d4af37]" data-id="element-175" />
            </div>
            <p className="text-xs text-gray-500 uppercase tracking-widest" data-id="element-176">
              Contenido Premium
            </p>
          </div>

          {/* Decorative glow */}
          <div className="absolute inset-0 bg-[#d4af37] blur-[100px] opacity-10 -z-10" data-id="element-177" />
        </div>
      </div>
    </Section>;
}